import React from 'react';
import proptypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStoreId } from '@thd-nucleus/experience-context';
import { dataModel } from '../dataModel';
import { MobileCollectionInfo } from './mobile-collection-info/MobileCollectionInfo';

const { string } = proptypes;

export const CollectionInfoTabsMobile = ({ collectionId }) => {
  const storeId = useStoreId();
  const { data } = useDataModel('collection', { variables: { collectionId, storeId } });
  const { collection } = data || {};
  const { descriptors, details } = collection || {};
  const { description, descriptiveAttributes } = details || {};

  return (
    <div data-component="CollectionInfoTabsMobile">
      <MobileCollectionInfo
        descriptiveAttributes={descriptiveAttributes}
        description={description}
        descriptors={descriptors}
      />
    </div>
  );
};

CollectionInfoTabsMobile.displayName = 'CollectionInfoTabsMobile';

CollectionInfoTabsMobile.dataModel = dataModel;

CollectionInfoTabsMobile.propTypes = {
  collectionId: string.isRequired
};
